import React, { useState, useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { Container, CssBaseline, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
// import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from '@mui/icons-material/People';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import SettingsIcon from '@mui/icons-material/Settings';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CreateIcon from '@mui/icons-material/Create';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import { makeStyles } from '@material-ui/core/styles';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import AuthContext from '../contexts/AuthContext';
import DocumentMeta from 'react-document-meta';
import {
  AppBar,
  Avatar,
  Drawer,
  IconButton,
  List,
  ListItemText,
  Toolbar,
  Typography,
  Box,
  Divider,
  ListItemButton, ListItemIcon,
  Menu, MenuItem,
  Snackbar, Grow, Alert
} from '@mui/material';
import { setSnackDetails, setSweetAlert } from '../service/actions/common';

const drawerWidth = 280;
const useStyles = makeStyles(theme => ({
                            footer: {
                              position: 'fixed !important',
                              bottom: 60,
                              width: `${drawerWidth}px`,
                              height: 60,
                              textAlign: 'center'
                            }
                        })
                    );
const getMuiTheme = () =>
          createTheme({
            components: {
              MuiListItemButton: {
                styleOverrides: {
                  root: {
                    '&:hover': {
                      backgroundColor: '#D8E6F1', 
                      borderRadius:25,
                    },
                    "&$selected": {
                      backgroundColor: "#D8E6F1",
                      borderRadius:25,
                      "&:hover": {
                        backgroundColor: "#D8E6F1",
                        borderRadius:25,
                      },
                    },
                    "&.Mui-selected" : {
                      backgroundColor: "#D8E6F1",
                      borderRadius:25,
                    }
                  },
                },
              },
              overrides: {
                  MuiOutlinedInput: {
                      multiline: {
                          fontWeight: 'bold',
                          fontSize: '20px',
                          color: 'purple',
                          width: '50vw'
                      }
                  }
              }
            },
          });
     
const DashboardLayout = ({ children }) => {

  const dispatch = useDispatch();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const { user, logout } = useContext(AuthContext);
  const snackData = useSelector((state) => state.snackData);
  const swData = useSelector((state) => state.swData);
  const metaData = useSelector((state) => state.metaData);
  const superUser = useSelector((state) => state.superUser);
  const classes = useStyles();
  const location = useLocation()
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleSnackClose = () => {
    dispatch(setSnackDetails({openState : false, message : ""}));
  }; 
  const handleSwCancel = () => {
    dispatch(setSweetAlert({open : false, title : ""}));
  }; 
  const handleSwConfirm = () => {
    dispatch(setSweetAlert({open : false, title : ""}));
    window.location.reload(false);    
  };

  const updateSelectedIndex = async () => {
    let selectedIndex = 1;
    const pathRgx = /\//g;
    const childroutecount = ((location.pathname || '').match(pathRgx) || []).length
    const llocc = childroutecount > 1 ? location.pathname.slice(0, location.pathname.lastIndexOf('/')) : location.pathname;
    switch (llocc) {
        case "/app-users":
        case "/user/":
          selectedIndex = 1;
          break;
        case "/reports":
          selectedIndex = 2;
          break;
        case "/contractor-users":
        case "/contractor-users/":
          selectedIndex = 3;
          break;
        case "/transactions":
          selectedIndex = 4;
          break;
        case "/admin-users":
        case "/admin-user":
          selectedIndex = 5;
          break;
        case "/gpt-prompts":
          selectedIndex = 6;
          break;
        case "/settings":
          selectedIndex = 7;
          break;
        default:
          selectedIndex = 1;
      }
      setSelectedIndex(selectedIndex);
  };
  const [selectedIndex, setSelectedIndex] = useState(1);
  const handleListItemClick = (event, index) => {
    setSelectedIndex(index);
  };
  const drawerLinks = (
    <ThemeProvider theme={getMuiTheme()}>
    <div>
      <List>
        {/* <ListItemButton component={Link} to="/dashboard">
            <ListItemIcon><DashboardIcon /></ListItemIcon>
            <ListItemText primary="Dashboard" />
        </ListItemButton > */}
        <ListItemButton 
            selected={selectedIndex === 1} 
            onClick={(event) => handleListItemClick(event, 1)} 
            component={Link}
            to="/app-users"
          >
            <ListItemIcon><AccountCircleIcon /></ListItemIcon>
            <ListItemText primary="System Users" />
        </ListItemButton >
        <ListItemButton 
            selected={selectedIndex === 2} 
            onClick={(event) => handleListItemClick(event, 2)} 
            component={Link}
            to="/reports"
          >
            <ListItemIcon><ReceiptOutlinedIcon /></ListItemIcon>
            <ListItemText primary="Reports" />
        </ListItemButton >
        <ListItemButton 
            selected={selectedIndex === 3} 
            onClick={(event) => handleListItemClick(event, 3)} 
            component={Link}
            to="/contractor-users"
          >
            <ListItemIcon><PeopleIcon /></ListItemIcon>
            <ListItemText primary="Preferred Contractors" />
        </ListItemButton >
        <ListItemButton 
            selected={selectedIndex === 4} 
            onClick={(event) => handleListItemClick(event, 4)} 
            component={Link}
            to="/transactions"
          >
            <ListItemIcon><AccountBalanceWalletIcon /></ListItemIcon>
            <ListItemText primary="Transactions" />
        </ListItemButton >
        <ListItemButton 
            selected={selectedIndex === 5} 
            onClick={(event) => handleListItemClick(event, 5)} 
            component={Link}
            to="/admin-users"
          >
            <ListItemIcon><SupervisedUserCircleIcon /></ListItemIcon>
            <ListItemText primary="Admin users" />
        </ListItemButton >
      </List>
      <List className={classes.footer}>
        <ListItemButton 
            selected={selectedIndex === 6} 
            onClick={(event) => handleListItemClick(event, 6)} 
            component={Link}
            to="/gpt-prompts"
          >
            <ListItemIcon><CreateIcon /></ListItemIcon>
            <ListItemText primary="GPT Prompts" />
        </ListItemButton >
        <ListItemButton 
            selected={selectedIndex === 7} 
            onClick={(event) => handleListItemClick(event, 7)} 
            component={Link}
            to="/settings"
          >
            <ListItemIcon><SettingsIcon /></ListItemIcon>
            <ListItemText primary="System Variables" />
        </ListItemButton >
      </List>
    </div>
    </ThemeProvider>
  );

  const drawer = (
    <div>
      <Toolbar />
      <Divider />
      {drawerLinks}
    </div>
  );

  useEffect(() => {
    updateSelectedIndex();
    // eslint-disable-next-line
  }, []);
  
  return (
    <Box sx={{ display: 'flex', backgroundColor:'#F0F2FC' }}>
      <CssBaseline />
      <DocumentMeta {...metaData} />
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={snackData.openState}
        autoHideDuration={6000}
        TransitionComponent={Grow}
        onClose={handleSnackClose}
      >
        <Alert
          onClose={handleSnackClose}
          severity={snackData.severity}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {snackData.message}
        </Alert>
      </Snackbar>

      <Dialog
        open={swData.open}
        fullWidth={true}
        maxWidth="xs"
        onClose={handleSwCancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{ justifyContent: 'center' }}
      >
        <DialogTitle id="alert-dialog-title" sx={{ textAlign: 'center' }}>
          {swData.title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {swData.description}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center' }}>
          <Button variant="contained" onClick={handleSwConfirm} autoFocus>
            Try Again
          </Button>
        </DialogActions>
      </Dialog>

      <AppBar
        position="fixed"
        sx={{
          width: { sm: '100%' },
          ml: { sm: `${drawerWidth}px` },
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backgroundColor : '#D8E6F1',
          color : '#000'
        }}
      >
        <Toolbar direction="row" sx={{ justifyContent: "space-between" }}>
          <Box sx={{ display: 'flex', alignItems:'center' }}>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2, display: { sm: 'none' } }}
            >
              <MenuIcon />
            </IconButton>
            <Avatar 
              alt="Logo" 
              src="/irp-logo.png" 
              variant="rounded" 
              sx={{
                  height: 48,
                  width: 48,
                  maxHeight: { xs: 233, md: 167 },
                  maxWidth: { xs: 350, md: 250 },
                }} />
            <Typography variant="h6" noWrap component="div" sx={{ ml: 2 }}>
              InspectReply AI
            </Typography>
          </Box>
          <Box sx={{ ml: "auto" }}>
            <Typography onClick={handleMenu} variant="h6" noWrap component="div" sx={{ ml: 2, display:'flex', alignItems:'center' }}>
              {user ? superUser.full_name : 'Guest'}
              <ArrowDropDownIcon />
            </Typography>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              {/* <MenuItem onClick={handleClose}>Profile</MenuItem>
              <MenuItem onClick={handleClose}>My Account</MenuItem> */}
              <MenuItem onClick={logout}>Logout</MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{ flexGrow: 1, p: 1, width: { sm: `calc(100% - ${drawerWidth}px)` }, backgroundColor:'#F0F2FC' }}
      >
        <Toolbar />
        <Container maxWidth={false} component="main" sx={{ m: 0 }}>
          {children}
        </Container>
      </Box>
    </Box>
  );
};

export default DashboardLayout;